export const COOKIE_EMBED_NAME = 'APP_EMBEDDED';

export const ALLOWED_LINEUP_EMBED_ORIGINS = [
  'http://localhost:3000',
  'http://localhost:3001',
  'https://dev.mdlbeast.com',
  'https://mdlbeast.com',
] as const;

export const EMBED_PATH_PREFIX = '/embed';

export enum EmbedParam {
  /** Set by the rewrite: the lineup is inside someone else's page. */
  Embed = 'embed',
  /** Show the lineup hero. */
  Header = 'header',
  /** Show the controls that need a session, like favourite. */
  Auth = 'auth',
  /** Show the cookie consent popup. */
  Cookies = 'cookies',
}
